import type { ReactNode } from 'react';

/**
 * Двухколоночная раскладка полей в модальном окне на десктопе (на телефоне — одна колонка).
 *
 * Длинная форма в окне 560 px на экране 1440 занимает треть ширины и половину полей прячет под
 * прокрутку — при том, что справа пусто. Прокрутка внутри окна хуже длинного окна: не видно, что
 * поля кончились, и кнопка «Сохранить» стоит над невидимой частью формы. Поэтому окно становится
 * шире, а поля идут парами.
 *
 * Не всякое поле годится во вторую колонку: адрес, комментарий и список файлов в половине ширины
 * нечитаемы — их оборачивают в `FormGrid.Full`, и они занимают строку целиком.
 *
 * На телефоне колонка одна (стили под `.is-mobile`), поэтому обёртка безопасна для любой формы:
 * в шите порядок полей остаётся тем же, каким его видит десктоп сверху вниз.
 */
export function FormGrid({ children }: { children: ReactNode }) {
  return <div className="form-grid">{children}</div>;
}

/** Поле во всю ширину окна: адреса, комментарии, файлы, вложенные таблицы. */
function FormGridFull({ children }: { children: ReactNode }) {
  return <div className="form-grid__full">{children}</div>;
}

FormGrid.Full = FormGridFull;
